export class ProductSupport {
    tmall = false
}

export default class ProductConfig {
    support = new ProductSupport()
}